<template>
  <div class="seller-settings">
    <div class="settings-tabs seller-settings-network">
      <div
        v-for="tab in tabs"
        :key="tab.key"
        :class="[tab.tabClass || '', { active: tab.key === activeTabKey }]"
        class="settings-tab"
        @click="activeTabKey = tab.key">
        {{ trans(tab.label) }}
      </div>
    </div>
    <component v-if="activeTab" :is="activeTab.component" :class="activeTab.class"></component>
  </div>
</template>
<script setup lang="ts">
  import { computed, markRaw, ref } from "vue";
  import { trans } from "@/utils/trans";
  import { AutoLive, Break } from "@/components/action-block/tabs/seller/settings-network";

  const activeTabKey = ref("auto_live");
  const activeTab = computed(() => tabs.value.find(({ key }) => key === activeTabKey.value));

  const tabs = ref([
    {
      label: "live.tabs.settings_network.auto_live_tab.label",
      key: "auto_live",
      component: markRaw(AutoLive),
      class: "auto-live-settings"
    },
    {
      label: "live.tabs.settings_network.break_tab.label",
      key: "break",
      component: markRaw(Break),
      class: "break-settings stage-b-item",
      tabClass: "stage-b-item"
    }
  ]);
</script>
